<template>
  <div class="IndoorVr">
    <div class="navlist">
      <div
        class="item"
        v-for="(item, index) in Vrlist"
        :key="index"
        :class="{ active: item.isactive }"
        @click="navclik(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <iframe class="iw-html-frame" scrolling="no" :src="Vrurl"></iframe>
    <div class="shengming">装修展示仅供优化示意，实际以交付为准</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      Vrurl: "https://www.720yun.com/vr/4e1jOrmOOw0",
      Vrlist: [
        {
          name: "A1",
          url: "https://www.720yun.com/vr/4e1jOrmOOw0",
          isactive: true
        },
        {
          name: "B1",
          url: "https://www.720yun.com/vr/4f3jOrmOOO4",
          isactive: false
        },
        {
          name: "C1",
          url: "https://www.720yun.com/vr/7f0jOrmOku8",
          isactive: false
        }
      ]
    };
  },
  created() {},
  mounted() {},
  methods: {
    navclik(index) {
      this.Vrurl = "";
      this.Vrurl = this.Vrlist[index].url;
      this.Vrlist.forEach(item => {
        item.isactive = false;
      });
      this.Vrlist[index].isactive = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.IndoorVr {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .navlist {
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    width: 38px;
    height: 148px;
    padding: 0;
    left: auto;
    left: 10px;
    top: 264px;
    /* top: 250px; */
    bottom: auto;
    margin: 0;
    z-index: 9999;
    border-radius: 18px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .item {
      width: 100%;
      line-height: 28px;
      height: 28px;
      text-align: center;
      /* border-bottom: 1px solid #fff; */
    }
    .active {
      /* background: #fff; */
      color: #d5bda6;
    }
  }
  .shengming {
    position: absolute;
    bottom: 20px;
    right: 10px;
    color: #fff;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/test.vue